import { HashRouter, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import AdminLogin from './components/AdminLogin.jsx';
import AdminDashboardPage from './components/AdminDashboardPage.jsx';
import StudentsPage from './components/StudentsPage.jsx';
import ImportStudentsPage from './components/ImportStudentsPage.jsx';
import UnitDetailPage from './components/UnitDetailPage.jsx';

export default function AdminRouter({ onLogout, adminUser, onAdminLogin }) {
  return (
    <HashRouter>
      <div style={{ minHeight: '100vh', background: '#f4f6f9' }}>
        {/* Top Navigation Bar */}
        <nav style={{
          background: '#1a2332', color: 'white', padding: '0 24px', height: 56,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)', position: 'sticky', top: 0, zIndex: 100
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
            <span style={{ fontWeight: 700, fontSize: 15, letterSpacing: 0.5 }}>IBMA ASSESSMENT ADMIN</span>
            <TopNavLinks />
          </div>
          {adminUser ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <span style={{ fontSize: 13, opacity: 0.7 }}>{adminUser?.name || adminUser?.username}</span>
              <button onClick={onLogout} style={{
                background: 'rgba(255,255,255,0.1)', color: 'white', border: 'none',
                padding: '6px 14px', borderRadius: 4, cursor: 'pointer', fontSize: 13
              }}>Sign out</button>
            </div>
          ) : null}
        </nav>

        {/* Page Content */}
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '24px 20px' }}>
          <Routes>
            <Route path="/login" element={<AdminLogin onLogin={onAdminLogin || (() => {})} />} />
            <Route path="/dashboard" element={adminUser ? <AdminDashboardPage /> : <Navigate to="/login" replace />} />
            <Route path="/import-students" element={adminUser ? <ImportStudentsPage /> : <Navigate to="/login" replace />} />
            <Route path="/students" element={adminUser ? <StudentsPage /> : <Navigate to="/login" replace />} />
            <Route path="/students/:studentUsername/unit/:unitCode" element={adminUser ? <UnitDetailPage /> : <Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to={adminUser ? "/dashboard" : "/login"} replace />} />
          </Routes>
        </div>
      </div>
    </HashRouter>
  );
}

function TopNavLinks() {
  return (
    <>
      <NavLink to="/dashboard">Dashboard</NavLink>
      <NavLink to="/import-students">Import Students</NavLink>
      <NavLink to="/students">Students</NavLink>
    </>
  );
}

function NavLink({ to, children }) {
  const location = useLocation();
  const active = location.pathname === to;

  return (
    <Link
      to={to}
      style={{
        color: active ? '#4a90d9' : 'rgba(255,255,255,0.6)',
        textDecoration: 'none', fontSize: 13, fontWeight: active ? 600 : 400,
        paddingBottom: 4, borderBottom: active ? '2px solid #4a90d9' : '2px solid transparent',
        transition: 'all 0.15s'
      }}
    >{children}</Link>
  );
}
